/* Golden Hopper live stock overlay, by Rivent.
 *
 * snippets/gh-live-stock.liquid puts the real, current availability into
 * window.GH_LIVE_STOCK, keyed by variant id. This walks the baked GH_DATA
 * snapshot in gh-products.js and corrects it before anything draws.
 *
 * ORDER MATTERS. This is loaded with `defer`, between gh-products.js and
 * gh-lib.js. Deferred classic scripts run in document order, so GH_DATA exists
 * by the time this runs, and gh-p1.js has not yet read it. gh-p1.js only ever
 * copies the `opts` of a variant, never its availability, so correcting the
 * objects in place here is enough.
 *
 * It fails quietly and changes nothing if either side is missing. A variant id
 * Shopify did not report is left exactly as the snapshot had it, which is the
 * safe direction: it does not invent a sold out badge for a product it simply
 * was not told about.
 *
 * Add ?ghstock=1 to any product URL to see in the console what it corrected.
 */
(function () {
  var live = window.GH_LIVE_STOCK;
  if (!live || !window.GH_DATA || !window.GH_DATA.products) { return; }

  var changed = [];
  var products = window.GH_DATA.products;

  for (var i = 0; i < products.length; i++) {
    var variants = products[i].variants || [];
    for (var j = 0; j < variants.length; j++) {
      var state = live[variants[j].id];
      if (typeof state === 'boolean' && variants[j].available !== state) {
        variants[j].available = state;
        changed.push(products[i].handle + ' ' + (variants[j].opts
          ? JSON.stringify(variants[j].opts) : variants[j].id) + ' -> ' + state);
      }
    }
  }

  window.GH_STOCK_OVERRIDES = changed;
  if (window.console && window.location.search.indexOf('ghstock') > -1) {
    console.log('GH live stock: ' + changed.length + ' corrected', changed);
  }
})();
